import axiosInstance from "../../lib/axios";

export const useLoginFunc = () => {

    const handleGoogleSingin = async () => {
        const response = await axiosInstance.get("/auth/google/url");

        if (response.status === 200) {
            const url = response.data?.url
            window.location.href = url
        }
        else {
            console.log("FAILED GOOGLE REDIRECT::", response.data)
        }
    };

    const handlePasswordSignin = async ({ username, password }) => {
        const response = await axiosInstance.post(`/auth/login`, {
        username,
        password,
        });

        const data = response.data;

        if (data?.access_token) {
        localStorage.setItem("token", data.access_token);
        }

        if (data?.refresh_token) {
        localStorage.setItem("refresh_token", data.refresh_token);
        }

        if (data?.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
        }

        window.location.href = "/dashboard";

        return data;
    };

    return {
        handleGoogleSingin,
        handlePasswordSignin
    }
}
